// Login timeouts
export const TIMEOUT_VALUE = 1000;
export const CALLBACK_TIMEOUT = 500;
